/**
 * Body editor for the cleanup step: the field to clean plus the
 * null-replacement mode (false / true / 0).
 */
import React from "react"
import { Radio } from "antd"
import type { RadioChangeEvent } from "antd"
import { QueryBuilderStore } from "stores/queryBuilderStore"
import { CleanupStep } from "types/queryBuilder.types"
import SingleFieldSlot from "../SingleFieldSlot.component"
import { StepBodyProps } from "./stepBodyProps"

export interface CleanupStepBodyProps extends StepBodyProps<CleanupStep> {
  setSingle: QueryBuilderStore["setStepSingleSource"]
  setCleanupMode: QueryBuilderStore["setCleanupMode"]
}

const CleanupStepBody: React.FC<CleanupStepBodyProps> = ({
  step,
  setSingle,
  setCleanupMode,
}) => (
  <>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Field to clean:</span>
      <SingleFieldSlot
        value={step.source}
        onChange={(v) => setSingle(step.id, v)}
        placeholder="Drag the field to modify"
      />
    </div>
    <div className="qc-step__field-row">
      <span className="qc-step__field-label">Replace nulls with:</span>
      <Radio.Group
        value={step.mode}
        onChange={(e: RadioChangeEvent) =>
          setCleanupMode(step.id, e.target.value as CleanupStep["mode"])
        }
        size="small"
      >
        <Radio.Button value="false">false</Radio.Button>
        <Radio.Button value="true">true</Radio.Button>
        <Radio.Button value="zero">0 (numeric)</Radio.Button>
      </Radio.Group>
    </div>
  </>
)

export default CleanupStepBody
